import React, { useState } from "react";
import "../styles/SignupPopup.css";
import {
  fetchSubscriptionCheckUserExistsApi,
  fetchSubscriptionRegisterUserApi,
} from "../api/api";
import Loginpopup from "./Loginpopup";
import { useNavigate } from "react-router-dom";
import ForgotDetailsModal from "./ForgotDetail";

const SignupPopup = ({
  showPopup,
  handleClose,
  setToken,
  hederLogin,
  disableClosebtn = false,
  withoutloginredirect = "",
  customError="",
  customId=""
}) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPopupLogin, setShowPopupLogin] = useState(hederLogin);
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const navigate = useNavigate();


  if (!showPopup) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = async () => {
    const errors = {};
    const { email, password, confirmPassword } = formData;

    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errors.email = "Invalid email format";
    } else {
      try {
        const res = await fetchSubscriptionCheckUserExistsApi(email);
        if (res && res.statuscode === 200) {
          errors.email = "This email already exists";
        }
      } catch (err) {
        console.error("Email check failed:", err);
      }
    }

    if (!password.trim()) errors.password = "Password is required";
    if (!confirmPassword.trim()) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCloseLogin = () => {
    setShowPopupLogin(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const isValid = await validate();
    if (!isValid) {
      setLoading(false);
      return;
    }

    try {
      const res = await fetchSubscriptionRegisterUserApi({
        username: formData.email,
        password: formData.password,
        subscriptionid: 1,
        productid: 1,
      });

      if (res.statuscode === 200) {
        setSuccessMessage("Registration successful! Redirecting to login...");
        setError("");
        setTimeout(() => {
          setShowPopupLogin(true);
        }, 2000);
      } else {
        setError(res.message || "Registration failed. Please try again.");
      }
    } catch (err) {
      setError("An error occurred while registering your account.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseForgot = () => {
    setShowForgot(false);
    handleClose()
  };

  return (
    <div className="signup-popupOverlay">
      <div className="signup-popup" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        {!disableClosebtn && (
          <div className="signup-header">
            <button className="signup-closeBtnLeft" onClick={handleClose}>
              ×
            </button>
          </div>
        )}

        {!showPopupLogin && !showForgot ? (
          <>
            <h2 className="signup-title">Sign Up for Free</h2>

            {error && <p className="error-text">{error}</p>}
            {successMessage && <p className="success-text">{successMessage}</p>}

            <form onSubmit={handleSubmit} className="signup-form-popup" autoComplete="off">
              <label style={{textAlign:'left'}}>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
                className={fieldErrors.email ? "input-error" : ""}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                inputMode="email"
              />
              {fieldErrors.email && (
                <p className="field-error-signpopup">{fieldErrors.email}</p>
              )}

              <label style={{textAlign:'left'}}>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  className={fieldErrors.password ? "input-error" : ""}
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? "Hide" : "Show"}
                </span>
              </div>
              {fieldErrors.password && (
                <p className="field-error-signpopup">{fieldErrors.password}</p>
              )}

              <label style={{textAlign:'left'}}>Confirm Password</label>
              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={fieldErrors.confirmPassword ? "input-error" : ""}
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                >
                  {showConfirmPassword ? "Hide" : "Show"}
                </span>
              </div>
              {fieldErrors.confirmPassword && (
                <p className="field-error-signpopup">{fieldErrors.confirmPassword}</p>
              )}

              <button
                type="submit"
                className="signup-submitBtn"
                disabled={loading}
              >
                {loading ? "Signing Up..." : "Sign Up"}
              </button>
            </form>

            <div className="signup-footer">
              <a
                onClick={() => setShowPopupLogin(true)}
                className="signup-footer-left"
              >
                Already have an account? Log In
              </a>
              <a
                onClick={() => {
                  handleClose();
                  navigate("/pricing");
                }}
                className="signup-footer-right"
              >
                Want full access? See our Pro Plan
              </a>
            </div>
          </>
        ) : (
          <Loginpopup
            showPopup={showPopupLogin}
            handleClose={handleCloseLogin}
            handleClose2={handleClose}
            setToken={setToken}
            withoutloginredirect={withoutloginredirect}
            setShowForgot={setShowForgot}
            customError={customError}
            customId={customId}
          />
        )}

        {showForgot && 
        <ForgotDetailsModal
          open={showForgot}
          onClose={handleCloseForgot}
          withoutloginredirect={withoutloginredirect}
        />
      
      }
      </div>
    </div>
  );
};

export default SignupPopup;
